import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../config";
import Navbar from "../components/Navbar";
import { Container, Card, Button, Row, Col, Form } from "react-bootstrap";
import Swal from "sweetalert2";
const Profile = () => {
  const [error, setError] = useState(null);
  const [profile, setProfile] = useState(null);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const sessionDetails = JSON.parse(sessionStorage.getItem("user"));
  const userId = sessionDetails?.payLoad.user.Id;
  const fields = [
    "FirstName",
    "LastName",
    "Gender",
    "MobileNumber",
    "CNIC",
    "Age",
    "MartialStatus",
    "Address",
  ];
  const fetchProfile = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/patient/profile?patient_profile_id=${userId}`
      );
      const data = await response.json();
      if (data.statusCode === 1) {
        setProfile(data.payLoad);
        setFormData(data.payLoad); // Initialize form data
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchProfile();
  }, []);

  const handleSave = async () => {
    try {
      setIsSaving(true);
      const response = await fetch(
        `${API_BASE_URL}/patient/update-profile`,
        {
          method: "POST",
          body: JSON.stringify({
            patient_profile_id: userId,
            phone: formData.MobileNumber,
            FirstName: formData.FirstName,
            LastName: formData.LastName,
            CNIC: formData.CNIC,
            Gender: formData.Gender,
            Address: formData.Address,
            MartialStatus: formData.MartialStatus,
            Age: Number(formData.Age),
          }),
        }
      );

      const data = await response.json();

      if (data.statusCode === 1) {
        setProfile(formData);
        setIsEditing(false);
        setIsSaving(false);

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Profile updated successfully!",
          confirmButtonColor: "#3085d6",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: "Failed to update profile. Please try again.",
          confirmButtonColor: "#d33",
        });
        setIsSaving(false);
      }
    } catch (error) {
      console.error("Update failed:", error);
      setIsSaving(false);

      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "Failed to update profile. Please try again.",
        confirmButtonColor: "#d33",
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <Navbar />
      <Container className="mt-5">
        {loading ? (
          <Card className="shadow-lg rounded-4 px-4 border-0">
            <Card.Body>
              <Row>
                {[...Array(8)].map((_, i) => (
                  <Col xs={12} md={6} className="mb-3" key={i}>
                    <div className="placeholder-glow bg-light">
                      <div className="placeholder col-8 mb-2"></div>
                      <div className="placeholder col-12 py-3 rounded"></div>
                    </div>
                  </Col>
                ))}
              </Row>
            </Card.Body>
          </Card>
        ) : (
          <Card className="shadow-lg rounded-4 px-4 border-0">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="mb-0">Profile Information</h4>
                <div>
                  <Button
                    variant="primary"
                    onClick={() => setIsEditing(!isEditing)}
                  >
                    {isEditing ? "Cancel" : "Edit Profile"}
                  </Button>
                </div>
              </div>

              <Form>
                <Row>
                  {fields.map((field) => (
                    <Col xs={12} md={6} className="mb-2" key={field}>
                      <Form.Group controlId={`form${field}`}>
                        <Form.Label>
                          {field.replace(/([A-Z])/g, " $1")}
                        </Form.Label>

                        {isEditing ? (
                          field === "MartialStatus" ? (
                            <Form.Select
                              name={field}
                              value={formData[field] || ""}
                              onChange={handleChange}
                              className="form-control"
                            >
                              <option value="" disabled>
                                Select Status
                              </option>
                              <option value="Single">Single</option>
                              <option value="Married">Married</option>
                              <option value="Divorced">Divorced</option>
                              <option value="Widowed">Widowed</option>
                            </Form.Select>
                          ) : field === "Gender" ? (
                            <Form.Select
                              name={field}
                              value={formData[field] || ""}
                              onChange={handleChange}
                              className="form-control"
                            >
                              <option value="" disabled>
                                Select Gender
                              </option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="Other">Other</option>
                            </Form.Select>
                          ) : (
                            <Form.Control
                              type="text"
                              name={field}
                              className="text-capitalize"
                              value={formData[field] || ""}
                              onChange={handleChange}
                            />
                          )
                        ) : (
                          <Form.Control
                            readOnly
                            plaintext
                            className="ps-2 rounded text-capitalize"
                            value={profile[field] ?? "N/A"}
                            style={{
                              background: "#50c4cc69",
                            }}
                          />
                        )}
                      </Form.Group>
                    </Col>
                  ))}
                </Row>

                {isEditing && (
                  <div className="d-flex justify-content-end">
                    <div>
                      <Button
                        variant="success"
                        onClick={handleSave}
                        disabled={isSaving}
                      >
                        {isSaving ? "Saving ..." : " Save Changes"}
                      </Button>
                    </div>
                  </div>
                )}
              </Form>
            </Card.Body>
          </Card>
        )}
      </Container>
    </>
  );
};

export default Profile;
